"use strict"; // Copyright (c) Jupyter Development Team.
// Distributed under the terms of the Modified BSD License.

var _classCallCheck = require("/home/runner/work/RLeapFROGS/RLeapFROGS/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/home/runner/work/RLeapFROGS/RLeapFROGS/node_modules/@babel/runtime/helpers/createClass.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var signaling_1 = require("@phosphor/signaling");

var builder_1 = require("./builder");

var nbconvert_1 = require("./nbconvert");

var contents_1 = require("./contents");

var session_1 = require("./session");

var setting_1 = require("./setting");

var terminal_1 = require("./terminal");

var serverconnection_1 = require("./serverconnection");

var workspace_1 = require("./workspace");
/**
 * A Jupyter services manager.
 */


var ServiceManager = /*#__PURE__*/function () {
  /**
   * Construct a new services provider.
   */
  function ServiceManager() {
    var _this = this;

    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, ServiceManager);

    this._isDisposed = false;
    this._specsChanged = new signaling_1.Signal(this);
    this._isReady = false;
    this.serverSettings = options.serverSettings || serverconnection_1.ServerConnection.makeSettings();
    this.contents = new contents_1.ContentsManager(options);
    this.sessions = new session_1.SessionManager(options);
    this.settings = new setting_1.SettingManager(options);
    this.terminals = new terminal_1.TerminalManager(options);
    this.builder = new builder_1.BuildManager(options);
    this.workspaces = new workspace_1.WorkspaceManager(options);
    this.nbconvert = new nbconvert_1.NbConvertManager(options);
    this.sessions.specsChanged.connect(function (sender, specs) {
      _this._specsChanged.emit(specs);
    });
    this._readyPromise = this.sessions.ready.then(function () {
      if (_this.terminals.isAvailable()) {
        return _this.terminals.ready;
      }
    });

    this._readyPromise.then(function () {
      _this._isReady = true;
    });
  }
  /**
   * A signal emitted when the kernel specs change.
   */


  _createClass(ServiceManager, [{
    key: "specsChanged",
    get: function get() {
      return this._specsChanged;
    }
    /**
     * Test whether the service manager is disposed.
     */

  }, {
    key: "isDisposed",
    get: function get() {
      return this._isDisposed;
    }
    /**
     * Dispose of the resources used by the manager.
     */

  }, {
    key: "dispose",
    value: function dispose() {
      if (this.isDisposed) {
        return;
      }

      this._isDisposed = true;
      signaling_1.Signal.clearData(this);
      this.contents.dispose();
      this.sessions.dispose();
      this.terminals.dispose();
    }
    /**
     * The kernel spec models.
     */

  }, {
    key: "specs",
    get: function get() {
      return this.sessions.specs;
    }
    /**
     * Test whether the manager is ready.
     */

  }, {
    key: "isReady",
    get: function get() {
      return this._isReady;
    }
    /**
     * A promise that fulfills when the manager is ready.
     */

  }, {
    key: "ready",
    get: function get() {
      return this._readyPromise;
    }
  }]);

  return ServiceManager;
}();

exports.ServiceManager = ServiceManager;